import { InfoCard, InfoCardContent, InfoCardText, InfoCardTitle, NotesInput, SelectableOption } from './index.styled'

import useInfo from './useInfo'
import { APIStatus } from '../../../../../redux/types'

export const Info = () => {
  const { notesValue, handleNotesChange, handlePriorityToggle, priorityAnswersStatus, hasMaxPriorities, filteredInfo } =
    useInfo()

  return (
    <>
      {filteredInfo?.map((group: any) => (
        <InfoCard key={group.title}>
          <InfoCardTitle>{group.title}</InfoCardTitle>
          <InfoCardContent>
            {group.responseOptions.map((ro: any) => {
              const priority = ro.priority || 0
              const isSelected = priority > 0
              const isLoading = priorityAnswersStatus === APIStatus.pending
              const isDisabled = isLoading || (!isSelected && hasMaxPriorities)

              return (
                <SelectableOption
                  key={ro.id}
                  $selected={isSelected}
                  $priority={priority}
                  onClick={() => !isDisabled && handlePriorityToggle(ro.id)}
                  $disabled={isDisabled}
                >
                  <InfoCardText $bold={isSelected}>{ro.option.text}</InfoCardText>
                </SelectableOption>
              )
            })}
          </InfoCardContent>
        </InfoCard>
      ))}

      <NotesInput placeholder="Type here" value={notesValue} onChange={(e) => handleNotesChange(e.target.value)} />
    </>
  )
}
